export function buildOrgLogoUrl(logo?: string): string | undefined {
  if (!logo) {
    return undefined;
  }
  if (logo.startsWith('http')) {
    return logo;
  }
  const apiUrl = typeof window.getApiUrl === 'function' ? window.getApiUrl() : '';
  return `${apiUrl}/v1/images/org/${logo}`;
}
